<template>
  <main id="login" class="authentication-page">
    <div class="authentication-page__glow authentication-page__glow--top"></div>
    <div class="authentication-page__glow authentication-page__glow--bottom"></div>
    <router-view></router-view>
    <footer class="authentication-page__footer">
      Powered by <strong>taleem.app</strong>
    </footer>
  </main>
</template>
<script>
import authService from "./store.js";
import RegisterStoreModule from "@/mixins/RegisterStoreModule";
export default {
  name: "authentication",
  mixins: [RegisterStoreModule],
  created() {
    this.registerStoreModule("auth", authService);
    const loginToken = localStorage.getItem(
      `${process.env.VUE_APP_STORAGE_PREFIX}token`
    );
    if (loginToken) {
      this.$router.push({ path: "/" });
    }
  },
};
</script>
<style scoped>
.authentication-page {
  position: relative;
  display: flex;
  min-height: 100vh;
  padding: 40px 24px 64px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #f6f8f6;
}

.authentication-page__glow {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}

.authentication-page__glow--top {
  top: -220px;
  right: -160px;
  width: 520px;
  height: 520px;
  background: rgba(67, 160, 71, 0.08);
}

.authentication-page__glow--bottom {
  bottom: -250px;
  left: -180px;
  width: 560px;
  height: 560px;
  border: 70px solid rgba(67, 160, 71, 0.05);
}

.authentication-page__footer {
  position: absolute;
  right: 28px;
  bottom: 22px;
  color: #8a958d;
  font-size: 12px;
}

.authentication-page__footer strong {
  color: #31863a;
}

@media (max-width: 600px) {
  .authentication-page {
    padding: 24px 16px 56px;
  }

  .authentication-page__footer {
    right: 0;
    left: 0;
    text-align: center;
  }
}
</style>
